import { normalizeKey } from '../../shared/verteoffice/exports/helpers/helpers'
import type { DomainConfigItem } from './domainConfig'

/**
 * Builds a flat lookup from normalized activity name → max_hours, reading
 * extras.max_hours from domain rows whose type is ACTIVITY_OBJECTIVE_* or
 * SPECIFIC_ACTIVITY_*. Only finite positive numbers are accepted; everything
 * else is ignored (the caller falls back to DEFAULT_WORKLOG_MAX_HOURS = 2).
 *
 * Precedence when two domain types share the same normalized name: last write
 * wins, but in practice names are unique across objective/specific domains.
 */
export function buildActivityMaxHoursLookup(
  domainsData: Record<string, Array<{ name: string; extras?: any }>> | undefined,
  config: DomainConfigItem[]
): Record<string, number> {
  if (!domainsData) return {}

  const lookup: Record<string, number> = {}

  for (const item of config) {
    if (
      !item.type.startsWith('ACTIVITY_OBJECTIVE_') &&
      !item.type.startsWith('SPECIFIC_ACTIVITY_')
    ) {
      continue
    }

    const rows = domainsData[item.alias] ?? []
    for (const row of rows) {
      const maxHours = row.extras?.max_hours
      if (typeof maxHours === 'number' && Number.isFinite(maxHours) && maxHours > 0) {
        lookup[normalizeKey(row.name)] = maxHours
      }
    }
  }

  return lookup
}
